/**
 * Prescription Reason Constants
 *
 * Values synced with backend PrescriptionReasonEnum.
 * @see backend/src/backend/db/constants/prescription_reason.py
 */
import { intl } from "dmsbasereact";

// Enum names (keys stored in database)
export const PrescriptionReasonEnum = {
    TREATMENT_CHANGE: "TREATMENT_CHANGE",
    ADVERSE_REACTION: "ADVERSE_REACTION",
    DISEASE_PROGRESSION: "DISEASE_PROGRESSION",
    INCORRECT_PATIENT: "INCORRECT_PATIENT",
    INCORRECT_DOSAGE: "INCORRECT_DOSAGE",
    INCORRECT_CYCLE: "INCORRECT_CYCLE",
    PREGNANCY: "PREGNANCY",
    DEATH: "DEATH",
    HEALTH_INSURANCE_APPROVAL: "HEALTH_INSURANCE_APPROVAL",
    MEDICATION_UNAVAILABILITY: "MEDICATION_UNAVAILABILITY",
};

export const PrescriptionReason = {
    /**
     * Get translated text for a prescription reason name
     * @param {string} name - The reason name (enum key)
     * @returns {string} Translated text
     */
    getText: (name) => {
        switch (name) {
            case PrescriptionReasonEnum.TREATMENT_CHANGE:
                return intl.get("TREATMENT_CHANGE").d("Treatment Change");
            case PrescriptionReasonEnum.ADVERSE_REACTION:
                return intl.get("ADVERSE_REACTION").d("Adverse Reaction");
            case PrescriptionReasonEnum.DISEASE_PROGRESSION:
                return intl.get("DISEASE_PROGRESSION").d("Disease Progression");
            case PrescriptionReasonEnum.INCORRECT_PATIENT:
                return intl.get("INCORRECT_PATIENT").d("Incorrect Patient");
            case PrescriptionReasonEnum.INCORRECT_DOSAGE:
                return intl.get("INCORRECT_DOSAGE").d("Incorrect Dosage");
            case PrescriptionReasonEnum.INCORRECT_CYCLE:
                return intl.get("INCORRECT_CYCLE").d("Incorrect Cycle");
            case PrescriptionReasonEnum.PREGNANCY:
                return intl.get("PREGNANCY").d("Pregnancy");
            case PrescriptionReasonEnum.DEATH:
                return intl.get("DEATH").d("Death");
            case PrescriptionReasonEnum.HEALTH_INSURANCE_APPROVAL:
                return intl.get("HEALTH_INSURANCE_APPROVAL").d("Health Insurance Approval");
            case PrescriptionReasonEnum.MEDICATION_UNAVAILABILITY:
                return intl.get("MEDICATION_UNAVAILABILITY").d("Medication Unavailability");
            default:
                return name || intl.get("Unknown").d("Unknown");
        }
    },
};

/**
 * Hook to get prescription reason options for select components
 * @returns {Function} Function that returns translated options
 */
export const usePrescriptionReasonOptions = () => {
    return Object.values(PrescriptionReasonEnum).map(name => ({
        value: name,
        label: PrescriptionReason.getText(name),
    }));
};
